import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import CountWithDescription from '@hkm/components/Attendant/SheetSummary/body/CountWithDesciption/CountWithDescription';
import SheetsSummaryAccordion from '@hkm/components/Attendant/SheetSummary/body/SheetSummaryAccordion/SheetsSummaryAccordion';
import { SheetSummaryGuestServiceStatus } from '@hkm/components/Attendant/SheetSummary/models/SheetSummaryGuestServiceStatus';
import { selectEffectiveValues } from '@hkm/components/Menu/PropertySelector/domain/selectors';
import { GuestServiceStatusType } from '@hkm/shared/enum/guestServiceStatusType';

import { AcFlex } from '@ac/mobile-components/dist/components/flex';
import { AcText } from '@ac/mobile-components/dist/components/text';
import {
  FlexDirection,
  Icon,
  TextSize,
  TextWeight
} from '@ac/mobile-components/dist/enums';

export interface GuestServiceStatusProps {
  guestServiceStatus: SheetSummaryGuestServiceStatus;
}

export const GuestServiceStatus: React.FC<GuestServiceStatusProps> = (
  props: GuestServiceStatusProps
) => {
  const { t } = useTranslation();
  const effectiveValues = useSelector(selectEffectiveValues)!;
  const {
    doNotDisturb,
    serviceDeferred,
    serviceRefused,
    serviceRequested,
    total
  } = props.guestServiceStatus;
  const renderSubtitle = useMemo(
    () => (
      <AcText
        size={TextSize.H1}
        weight={TextWeight.Semibold}
        testSelector="guest-service-status-total"
      >
        {total}
      </AcText>
    ),
    [total]
  );

  const renderContent = useMemo(
    () => (
      <AcFlex direction={FlexDirection.column}>
        {effectiveValues.guestServiceStatusDoNotDisturbed && (
          <CountWithDescription
            count={doNotDisturb}
            description={t(
              `GLOBAL.GUEST_SERVICE_STATUS.VALUES.${GuestServiceStatusType.DoNotDisturb}`
            )}
          />
        )}

        {effectiveValues.guestServiceStatusServiceRefused && (
          <CountWithDescription
            count={serviceRefused}
            description={t(
              `GLOBAL.GUEST_SERVICE_STATUS.VALUES.${GuestServiceStatusType.ServiceRefused}`
            )}
          />
        )}

        {effectiveValues.guestServiceStatusServiceDeferred && (
          <CountWithDescription
            count={serviceDeferred}
            description={t(
              `GLOBAL.GUEST_SERVICE_STATUS.VALUES.${GuestServiceStatusType.ServiceDeferred}`
            )}
          />
        )}

        {effectiveValues.guestServiceStatusServiceRequested && (
          <CountWithDescription
            count={serviceRequested}
            description={t(
              `GLOBAL.GUEST_SERVICE_STATUS.VALUES.${GuestServiceStatusType.ServiceRequested}`
            )}
          />
        )}
      </AcFlex>
    ),
    [doNotDisturb, serviceRefused, serviceDeferred, serviceRequested]
  );

  return (
    <SheetsSummaryAccordion
      icon={Icon.GuestServiceStatus}
      title={t('GLOBAL.GUEST_SERVICE_STATUS.TITLE')}
      renderSubtitle={renderSubtitle}
      renderContent={renderContent}
      expandDisabled={total === 0}
    />
  );
};

export default memo(GuestServiceStatus);



// WEBPACK FOOTER //
// ./src/components/Attendant/SheetSummary/body/GuestServiceStatus/GuestServiceStatus.tsx